<div class="modal-header"><h2 class="modal-title">Bulk Edit</h2></div>
<div class="modal-body">
    <div class="mb-1">{{ rowCount }} rows selected</div>
    <dx-form *ngIf="bulkInfo" [formData]="bulkInfo" [colCount]="2">
        <dxi-item
            dataField="salesRepId"
            [label]="{ text: 'Sales Reps' }"
            editorType="dxSelectBox"
            [editorOptions]="{ items: salesReps, valueExpr: 'id', displayExpr: 'name', width: '100%' }"
        >
        </dxi-item>
        <dxi-item dataField="clearSalesRep" editorType="dxCheckBox" [label]="{ text: 'Clear' }"></dxi-item>
        <dxi-item [label]="{ text: 'Past Due' }">
            <div *dxTemplate>
                <dx-date-box [(value)]="bulkInfo.pastDue" (valueChanged)="pastDueDateChanged($event)" [width]="'100%'"></dx-date-box>
            </div>
        </dxi-item>
        <dxi-item dataField="clearPastDue" editorType="dxCheckBox" [label]="{ text: 'Clear' }" (onValueChanged)="clearPastDueChanged($event)"></dxi-item>
        <dxi-item
            dataField="pricingTierId"
            [label]="{ text: 'Tier Override' }"
            editorType="dxSelectBox"
            [editorOptions]="{ items: pricingTiers, valueExpr: 'id', displayExpr: 'name' }"
        ></dxi-item>
        <dxi-item dataField="clearPricingTier" editorType="dxCheckBox" [label]="{ text: 'Clear' }"></dxi-item>
        <dxi-item
            dataField="inactiveStatus"
            [label]="{ text: 'Mark as' }"
            editorType="dxRadioGroup"
            [editorOptions]="{
                items: inactiveStatusOptions,
                layout: 'horizontal',
                stylingMode: 'outlined'
            }"
        >
        </dxi-item>
    </dx-form>
</div>

<div class="modal-footer">
    <button class="btn btn-success" (click)="save()" [disabled]="processing">Save</button>
    <button class="btn btn-default" (click)="close()">Cancel</button>
</div>
